
import React from "react";
import { useRef } from "react";
import { useEffect } from "react";

const TrustWidgetBig = props => {
    const trustpilotRef = useRef(null);

    useEffect(() => {
        // Load Trustpilot script dynamically
        const protocol = window.location.protocol === 'https:' ? 'https:' : 'http:';
        const scriptId = 'trustpilot-widget-script';
        
        if (!document.getElementById(scriptId)) {
            const script = document.createElement('script');
            script.id = scriptId;
            script.type = 'text/javascript';
            script.src = `${protocol}//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js`;
            script.async = true;
            document.head.appendChild(script);
            
            script.onload = () => {
                if (window.Trustpilot && trustpilotRef.current) {
                    window.Trustpilot.loadFromElement(trustpilotRef.current, true);
                }
            };
        } else if (window.Trustpilot && trustpilotRef.current) {
            window.Trustpilot.loadFromElement(trustpilotRef.current, true);
        }
    }, []);

    return (
        <div class="trustpilot-widget"
            ref={trustpilotRef}
            data-locale="en-US" data-template-id="53aa8807dec7e10d38f59f32" data-businessunit-id="55c4a9180000ff000581e1e8" data-style-height="150px" data-style-width="100%" data-token="49be0a3c-522b-4ee5-b903-3b42f8d72638">
            <a href="https://www.trustpilot.com/review/housesitmatch.com" target="_blank" rel="noopener">Trustpilot</a>
        </div>
    );
};

export default TrustWidgetBig;
